class FacetDrawer extends MainDrawer {
  constructor() {
    super();

    this.trigger = this.querySelector(".drawer__trigger");
    if (this.trigger) {
      this.trigger.addEventListener("click", () => this.loadAssets());
    }
  }

  loadAssets() {
    this.openDrawer();
    if (
      !document.getElementById("FACETSCSS") &&
      !document.getElementById("FACETSJS")
    ) {
      this.classList.add("loading");
    }
    loadCss("facets")
      .then(() => {
        this.classList.remove("loading");
      })
      .catch((error) => {
        console.error(error);
      });
    loadScript("facets").catch((error) => {
      console.error(error);
    });
  }
}
customElements.define("facet-drawer", FacetDrawer);

// Collection quick ATC swatches
(function () {
  // Helper: Fetch config for Shopify AJAX calls
  if (typeof fetchConfig !== "function") {
    window.fetchConfig = function (type = "json") {
      const config = {
        method: "POST",
        credentials: "same-origin",
        headers: { Accept: "application/json" },
      };
      if (type === "json") {
        config.headers["Content-Type"] = "application/json";
      }
      return config;
    };
  }

  // Helper: Shopify route fallback
  if (typeof window.routes === "undefined") {
    window.routes = {
      cart_update_url: "/cart/update.js",
    };
  }

  // Utility: Open and update cart drawer/modal
  function openCartDrawerAndUpdate(form) {
    setTimeout(() => {
      document.getElementById("modalAddToCart")?.classList.add("show");

      const cartNotification =
        document.querySelector("cart-notification") ||
        document.querySelector("cart-drawer");
      if (!cartNotification) return;

      const config = fetchConfig("javascript");
      config.headers["X-Requested-With"] = "XMLHttpRequest";
      delete config.headers["Content-Type"];

      const formElement =
        form instanceof HTMLFormElement
          ? form
          : document.querySelector('form[action="/cart/add"]');
      const formData = new FormData(formElement);

      const sections = cartNotification
        .getSectionsToRender()
        .map((section) => section.id)
        .join(",");
      formData.append("sections", sections);
      formData.append("sections_url", window.location.pathname);
      cartNotification.setActiveElement(document.activeElement);

      config.body = formData;

      fetch(window.routes.cart_update_url, config)
        .then((res) => {
          if (!res || !res.ok) {
            throw new Error('Failed to update cart');
          }
          return res.json();
        })
        .then((data) => {
          if (data && data.status) return;
          cartNotification.renderContents(data);
          cartNotification.classList.remove("is-empty");
        })
        .catch(console.error);
    }, 1000);
  }

  // Utility: Button loading state
  function toggleLoader(button, isLoading) {
    if (isLoading) {
      button.classList.add("is-loading");
      button.disabled = true;
      button.setAttribute("aria-busy", "true");
    } else {
      button.classList.remove("is-loading");
      button.disabled = false;
      button.removeAttribute("aria-busy");
    }
  }

  // ✅ Main reusable initializer
  window.initializeProductElements = function (container = document) {
    if (window.innerWidth <= 768) {
      container.querySelectorAll(".product-card").forEach((card) => {
        const firstSlider = card.querySelector(".media--primaryx");
        if (firstSlider) {
          firstSlider.classList.add("is-active");
        }
      });
    }

    const isMobileViewport = () => window.innerWidth <= 768;

    // --- Image Sliders & Swatches ---
    container.querySelectorAll(".product-card").forEach((card) => {
      const sliders = card.querySelectorAll(".product-image-slider");

      const updateSizeOptions = (productId) => {
        const sizeOptions = card.querySelectorAll(
          ".option-group-size .option-values"
        );
        sizeOptions.forEach((option) => {
          const isMatch = option.dataset.productId === productId;
          option.classList.toggle("is-active", isMatch);
        });
      };

      const syncPrimaryImageTabOrder = () => {
        card.querySelectorAll(".primary-image-for-product").forEach((el) => {
          const isVisible = el.style.display !== "none" && getComputedStyle(el).display !== "none";
          el.querySelectorAll("a").forEach((link) => {
            if (isVisible) {
              link.removeAttribute("tabindex");
            } else {
              link.setAttribute("tabindex", "-1");
            }
          });
        });
      };

      // ADA #328: On load, only the visible primary image link is tabbable
      syncPrimaryImageTabOrder();

      const showPrimaryImage = (productId) => {
        if (!productId) return;

        sliders.forEach((slider) => {
          slider.classList.remove("is-active");
        });

        card.querySelectorAll(".media--primary").forEach((media) => {
          media.style.display = "block";
        });
        card.querySelectorAll(".media--rollover").forEach((media) => {
          media.style.display = "";
          media.style.opacity = "";
        });

        // Show only the selected product flat image in primary media.
        card.querySelectorAll(".primary-image-for-product").forEach((el) => {
          el.style.display = el.dataset.productId === productId ? "block" : "none";
        });
        syncPrimaryImageTabOrder();

        updateSizeOptions(productId);
      };

      const activateSlider = (productId) => {
        if (!productId) return;

        card
          .querySelectorAll(".media--primary, .media--rollover")
          .forEach((media) => {
            media.style.display = "none";
          });

        sliders.forEach((slider) => {
          const isMatch = slider.dataset.productId === productId;
          slider.classList.toggle("is-active", isMatch);
        });

        card.querySelectorAll(".primary-image-for-product").forEach((el) => {
          el.style.display = el.dataset.productId === productId ? "block" : "none";
        });
        // Primary media is hidden while slider is active — keep those links out of tab order
        card.querySelectorAll(".primary-image-for-product a").forEach((link) => {
          link.setAttribute("tabindex", "-1");
        });

        updateSizeOptions(productId);
      };

      const applySwatchMediaState = (productId) => {
        if (isMobileViewport()) {
          activateSlider(productId);
          return;
        }
        showPrimaryImage(productId);
      };

      card
        .querySelectorAll(".product-form__input .swatch-wrapper")
        .forEach((swatch) => {
          swatch.addEventListener("click", () =>
            applySwatchMediaState(swatch.dataset.productId)
          );
        });

      const media = card.querySelector(".product-card__media");
      if (window.innerWidth > 768 && media) {
        const activateMediaSlider = () => {
          const selectedSwatch = card.querySelector(
            ".product-form__input .swatch-wrapper.is-selected"
          );
          if (selectedSwatch) {
            activateSlider(selectedSwatch.dataset.productId);
          } else {
            const mainSlider = card.querySelector(
              ".media--primaryx.product-image-slider"
            );
            if (mainSlider && mainSlider.dataset.productId) {
              activateSlider(mainSlider.dataset.productId);
            } else {
              const rolloverMedia = card.querySelector(".media--rollover");
              if (rolloverMedia) {
                rolloverMedia.style.display = "block";
                rolloverMedia.style.opacity = "1";
              }
            }
          }
        };

        const deactivateMediaSlider = () => {
          card.querySelectorAll(".product-image-slider").forEach((slider) => {
            slider.classList.remove("is-active");
          });
          const primaryMedia = card.querySelector(".media--primary");
          const rolloverMedia = card.querySelector(".media--rollover");
          if (primaryMedia) primaryMedia.style.display = "block";
          if (rolloverMedia) {
            rolloverMedia.style.display = "";
            rolloverMedia.style.opacity = "";
          }
          syncPrimaryImageTabOrder();
        };

        // Mouse hover: keep existing slider / multi-image behavior
        media.addEventListener("mouseenter", activateMediaSlider);
        media.addEventListener("mouseleave", deactivateMediaSlider);

        // Keyboard Tab: do NOT activate slider (that hides the focused link).
        // Hover image shows via CSS .media--rollover on :focus (YMAL pattern).
      }
    });

    // --- Color Option Groups ---
    container
      .querySelectorAll(".option-group-colors input")
      .forEach((input) => {
        input.addEventListener("change", function () {
          if (this.checked) {
            const selectedProductId = this.getAttribute("data-product-id");
            const quickAddContainer = this.closest(".quick-add-wraps");
            if (!quickAddContainer) return;

            quickAddContainer
              .querySelectorAll(".option-group-size .option-values")
              .forEach((group) => {
                group.classList.remove("is-active");
              });

            quickAddContainer
              .querySelectorAll(".option-group-size .option-values")
              .forEach((group) => {
                if (
                  group.getAttribute("data-product-id") === selectedProductId
                ) {
                  group.classList.add("is-active");
                }
              });

            // Sync primary image and slider to the selected color's product
            const card = quickAddContainer.closest(".product-card");
            if (card && selectedProductId) {
              if (window.innerWidth <= 768) {
                card
                  .querySelectorAll(".media--primary, .media--rollover")
                  .forEach((media) => {
                    media.style.display = "none";
                  });
                card.querySelectorAll(".product-image-slider").forEach((slider) => {
                  slider.classList.toggle(
                    "is-active",
                    slider.dataset.productId === selectedProductId
                  );
                });
              } else {
                card.querySelectorAll(".product-image-slider").forEach((slider) => {
                  slider.classList.remove("is-active");
                });
                card.querySelectorAll(".media--primary").forEach((media) => {
                  media.style.display = "block";
                });
                card.querySelectorAll(".media--rollover").forEach((media) => {
                  media.style.display = "";
                  media.style.opacity = "";
                });
              }

              card.querySelectorAll(".primary-image-for-product").forEach((el) => {
                el.style.display =
                  el.dataset.productId === selectedProductId ? "block" : "none";
              });
              card.querySelectorAll(".option-group-size .option-values").forEach((option) => {
                option.classList.toggle(
                  "is-active",
                  option.dataset.productId === selectedProductId
                );
              });
            }
          }
        });
      });

    // --- Quick Add Logic ---
    container.querySelectorAll(".quick-add-wraps").forEach((wrap) => {
      const addToCartBtn = wrap.querySelector(".quick-add-to-cart-btn");
      const radioInputs = wrap.querySelectorAll(
        'input[type="radio"][data-variant-id]'
      );

      let variantInput = wrap.querySelector(".selected-variant");
      if (!variantInput) {
        variantInput = document.createElement("input");
        variantInput.type = "hidden";
        variantInput.classList.add("selected-variant");
        wrap.appendChild(variantInput);
      }

      radioInputs.forEach((input) => {
        input.addEventListener("change", () => {
          if (!input.disabled) {
            variantInput.value = input.dataset.variantId || "";
          }
        });

        if (input.checked && !input.disabled) {
          variantInput.value = input.dataset.variantId || "";
        }
      });

      addToCartBtn?.addEventListener("click", function () {
        const variantId = variantInput.value;
        if (!variantId) {
          console.warn("No variant selected.");
          return;
        }

        toggleLoader(this, true);

        fetch("/cart/add.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          body: JSON.stringify({ id: variantId, quantity: 1 }),
        })
          .then((response) => {
            if (!response.ok) throw new Error("Failed to add to cart");
            return response.json();
          })
          .then((data) => {
            const icon = wrap.querySelector(".quick-add-icon");
            if (icon) {
              icon.classList.add("is-added");
              setTimeout(() => icon.classList.remove("is-added"), 2000);
            }

            const form = wrap.querySelector("form.product-form, form");
            openCartDrawerAndUpdate(form);

            wrap.classList.remove("is-active");
            document.documentElement.classList.remove("is-quick-open");
          })
          .catch(console.error)
          .finally(() => toggleLoader(addToCartBtn, false));
      });
    });

    // --- Quick Add Icon Click ---
    container.querySelectorAll(".quick-add-icon").forEach((icon) => {
      icon.addEventListener("click", function () {
        const wrap = this.closest(".quick-add-wraps");
        if (wrap) wrap.classList.add("is-active");
        document.documentElement.classList.add("is-quick-open");
      });
    });

    // --- Hide quick add on mouse leave (desktop) ---
    if (window.innerWidth > 768) {
      container.querySelectorAll(".quick-add-wraps").forEach((wrap) => {
        wrap.addEventListener("mouseleave", function () {
          this.classList.remove("is-active");
        });
      });
    }

    // --- Initialize product form input label click handlers ---
    container.querySelectorAll(".product-form__input").forEach((wrapper) => {
      // Skip if already initialized
      if (wrapper.hasAttribute("data-input-initialized")) return;

      const labels = wrapper.querySelectorAll("label");

      labels.forEach((label) => {
        label.addEventListener("click", () => {
          labels.forEach((l) => l.classList.remove("is-selected"));
          label.classList.add("is-selected");
        });
      });

      // Mark as initialized to prevent duplicate listeners
      wrapper.setAttribute("data-input-initialized", "true");
    });
  };

  // Global overlay handler (no need to re-run dynamically)
  document
    .querySelector(".quick-add-overlay")
    ?.addEventListener("click", () => {
      document.documentElement.classList.remove("is-quick-open");
      document.querySelectorAll(".quick-add-wraps").forEach((el) => {
        el.classList.remove("is-active");
      });
    });

  // 🔁 Initialize on page load
  document.addEventListener("DOMContentLoaded", () => {
    initializeProductElements();
  });
})();
